import { Selection, select } from "d3";
import "../../../styles/pages/Groups.scss";
import { _APP_DATA } from "../../data/AppData";
import { _SetGroupInUserInfo } from "../../data/ManageUserInfo";
import { IGroup } from "../../data/models/Entities";
import { _SvAlumnoClearChildsData } from "../../data/services/Alumno";
import { _CHAT_GRUPOS_MENSAJES_NOLEIDOS_MAP, _LoadUnreadedMessage } from "../../data/services/Chat";
import { _SvEscuelaClearKinderData } from "../../data/services/Escuela";
import { _ClearEventsData } from "../../data/services/Evento";
import { _SvGrupoClearMaestrosInfoData } from "../../data/services/Grupo";
import { _SvLogroClearData } from "../../data/services/Logro";
import { _SvUsuarioObtenerGrupos } from "../../data/services/Usuario";
import { _HashReplace } from "../../routes/UIManager";
import _L from "../../utils/Labels";
import { BaseUI } from "../bases/BaseUI";
import { Button } from "../components/Button";
import { EmptyTag } from "../components/EmptyTag";
import { LOADING } from "../components/Loading";
import { _CreateElementFromHTML } from "../utils/General";
import { _LogoutDialog } from "../views/LogoutDialog";
import ic_home from '/icons/ic_home.svg?raw';
import ic_exit_session from '/icons/ic_logout.svg?raw';

export class Groups extends BaseUI {

    private listGroupsContainer: Selection<HTMLDivElement, any, any, any>;

    private timmerLoadGroup: number = 1000 * 60;
    private idTimeoutLoadGroup: NodeJS.Timeout;
    private listGroups: Array<IGroup> = [];
    private isMainActive: boolean = true;
    private isSecundaryActive: boolean = true;
    private emptyTag: EmptyTag
    private failRequest: boolean = false

    constructor() {
        super({ addMainLogoOptions: false, addOptionsInHeader: false, addFooter: true, className: "main_groups" });

        this.listGroupsContainer = this.bodyContainer.append("div").classed("list-bubbles-group", true)
        this.emptyTag = new EmptyTag(this.listGroupsContainer.node())
            ._SetSVGIcon(ic_home)
            ._SetColor("var(--color-humor)")

        LOADING.Show();

        this.SetBubblesGroup(this.listGroups);
        this.CreateButtons();

        this.BuildHeader()
        this.Init();
    }

    private BuildHeader() {
        const divIcons = this.headerContainer.append("div").classed("div-options", true);

        divIcons.append(() => _CreateElementFromHTML(ic_exit_session))
            .classed("img-options-header", true)
            .classed("btn-class-room", true)
            .on("click", () => {
                _LogoutDialog()
            });
    }

    private Init() {
        this.LoadData();

        this.idTimeoutLoadGroup = setInterval(() => {
            this.LoadData();
        }, this.timmerLoadGroup);
    }

    private LoadData() {
        this.failRequest = false
        _SvUsuarioObtenerGrupos((result) => {
            if (!result) {
                this.failRequest = true
            }
            this.listGroups = result || [];
            this.FilterGroups();

            this.CheckMessageUnreaded();

            LOADING.Dismiss();
        });
    }

    private CheckMessageUnreaded() {
        this.listGroups.forEach(item => {
            _LoadUnreadedMessage((_) => {
                this.FilterGroups();
            }, item.IdGrupo);
        });
    }

    private SetBubblesGroup(listData: IGroup[]) {
        const bubblesgroup = this.listGroupsContainer.selectAll<HTMLDivElement, any>(".bubbles-group").data(listData);

        // const self = this;
        bubblesgroup.exit().remove();
        bubblesgroup.enter().append("div")
            .classed("bubbles-group", true)
            .each((_, i, divs) => {
                const elemnt = select(divs[i]);
                let bubble = elemnt.append("div").classed("bubble-group", true);
                bubble.append("h2");
                bubble.append("span").classed("n-messages", true);

            })
            .merge(bubblesgroup)
            .on('click', (_, d) => this.OnSelectedGroup(d))
            .each((datum, i, divs) => {
                const elemnt = select(divs[i]).select(".bubble-group");
                elemnt.classed("main", datum.EsPrincipal)
                elemnt.select("h2").text(datum.NombreGrupo)

                elemnt.select(".n-messages")
                    .text(datum.NMessages)
                    .classed("active", datum.NMessages > 0)
            });

        this.RefreshEmptyTag()

    }

    private CreateButtons() {
        const btnContainer = this.footerContainer.append("div").classed("list-buttons-group", true);
        const btnMain = new Button(btnContainer)
            .Title(_L("home.g_prim"))
            .Classed("main")
            .Classed("active")
            .OnClick(() => {
                const isActive = btnMain._button.classed("active");
                this.isMainActive = !isActive;
                btnMain._button.classed("active", this.isMainActive);

                if (this.failRequest)
                    this.LoadData()
                else
                    this.FilterGroups()
            });

        const btnSecundary = new Button(btnContainer)
            .Title(_L("home.g_sec"))
            .Classed("secundary")
            .Classed("active")
            .OnClick(() => {
                const isActive = btnSecundary._button.classed("active");
                this.isSecundaryActive = !isActive;
                btnSecundary._button.classed("active", this.isSecundaryActive);

                if (this.failRequest)
                    this.LoadData()
                else
                    this.FilterGroups()
            });
    }

    private FilterGroups() {
        let newData: Array<IGroup> = []
        if (this.isMainActive)
            newData = newData.concat(this.listGroups.filter(obj => obj.EsPrincipal));

        if (this.isSecundaryActive)
            newData = newData.concat(this.listGroups.filter(obj => !obj.EsPrincipal));

        newData = newData.sort((a, b) => a.IdGrupo - b.IdGrupo);

        newData.map(o => o.NMessages = _CHAT_GRUPOS_MENSAJES_NOLEIDOS_MAP.get(o.IdGrupo)?.countMsg || 0);

        this.SetBubblesGroup(newData);
    }

    private OnSelectedGroup(datum: IGroup) {
        LOADING.Show();

        this.EvaluateConfig(datum.IdNivel, (valid) => {
            if (!valid) return;
            const cambioEscuela = datum.IdEscuela != _APP_DATA.userData.IdKinder;

            _SetGroupInUserInfo(datum);
            _SvAlumnoClearChildsData();
            _ClearEventsData();
            _SvGrupoClearMaestrosInfoData();

            if (cambioEscuela) {
                _SvEscuelaClearKinderData();
                _SvLogroClearData();
            }

            LOADING.Dismiss();
            _HashReplace(datum.EsPrincipal ? "home" : "classroom");
        });
    }

    public OnDestroy(): void {
        clearInterval(this.idTimeoutLoadGroup);
        this.idTimeoutLoadGroup = null;
    }

    private RefreshEmptyTag() {
        let message: string
        if (this.failRequest) {
            message = _L("general.error")
        } else if (!this.listGroups.length) {
            message = _L("home.without_groups")
        } else if (!this.isMainActive && !this.isSecundaryActive) {
            message = _L("home.filter_required")
        } else if ((!this.isMainActive || !this.isSecundaryActive) && !this.listGroupsContainer.select(".bubbles-group").node()) {
            message = _L("home.groups_no_found")
        }
        if (message) {
            this.emptyTag._SetText(message)._ShowTag()
        } else {
            this.emptyTag._Remove()
        }
    }
}